function shouldUseNativeShopifyCheckout() {
  try {
    const checkbox = document.getElementById('CartDrawer-UseStoreCredit');
    if (checkbox) return checkbox.checked;
    return sessionStorage.getItem('useStoreCredit') === 'true';
  } catch (e) {
    return false;
  }
}

function getNativeCheckoutUrl() {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}checkout`;
}

if (!customElements.get('store-credit-toggle')) {
  customElements.define(
    'store-credit-toggle',
    class StoreCreditToggle extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('#CartDrawer-UseStoreCredit');
        if (!this.checkbox) return;

        try {
          this.checkbox.checked = sessionStorage.getItem('useStoreCredit') === 'true';
        } catch (e) {
          this.checkbox.checked = false;
        }

        this.checkbox.addEventListener('change', () => {
          try {
            if (this.checkbox.checked) {
              sessionStorage.setItem('useStoreCredit', 'true');
            } else {
              sessionStorage.removeItem('useStoreCredit');
            }
          } catch (e) {
            // sessionStorage may be unavailable
          }
        });
      }
    }
  );
}
// Handle Cart Checkout button clicks with premium animations
if (!customElements.get('cart-checkout-handler')) {
  customElements.define(
    'cart-checkout-handler',
    class CartCheckoutHandler extends HTMLElement {
      constructor() {
        super();
        this.clickPending = false;
        this.cleanupOnPageLoad();
        this.setupCheckoutHandler();
      }

      cleanupOnPageLoad() {
        // Clean up any leftover transition elements when page loads (e.g., from browser back button)
        const existingTransitions = document.querySelectorAll('.premium-checkout-transition');
        existingTransitions.forEach(el => el.remove());
        document.body.classList.remove('checkout-transitioning');
        
        // Clear the checkout flag if we're back on the page
        sessionStorage.removeItem('isGoingToCheckout');
      }

      setupCheckoutHandler() {
        const button = this.querySelector('button[name="checkout"]');
        if (!button) return;

        // Create overlay for "Checking Availability" message
        const overlay = this.createOverlay();
        this.style.position = 'relative';
        this.appendChild(overlay);

        button.addEventListener('click', (e) => {
          // If already processing, allow the click through
          if (this.clickPending) {
            return;
          }

          // Check if button is disabled
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
            return;
          }

          // Prevent immediate submission
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Show overlay with message and keep it visible
          overlay.style.display = 'flex';
          
          // Prevent any visual changes to the button
          button.style.pointerEvents = 'none';

          // After 1 second, change text and proceed with the action
          setTimeout(() => {
            // Change text to "Reserved for you" with special animation
            const messageSpan = overlay.querySelector('span');
            if (messageSpan) {
              messageSpan.textContent = window.buyItNowStrings?.reserved_for_you || 'Reserved for you';
              messageSpan.classList.add('reserved');
            }
            
            // Trigger premium page transition after a brief moment
            setTimeout(() => {
              this.showPremiumTransition();
              
              // Mark that we're allowing the next click
              this.clickPending = true;
              
              // Trigger the actual button click after transition starts
              setTimeout(() => {
                if (shouldUseNativeShopifyCheckout()) {
                  window.location.href = getNativeCheckoutUrl();
                  return;
                }
                button.click();
              }, 300);
            }, 400);
          }, 1000);
        }, { capture: true });
      }

      createOverlay() {
        const overlay = document.createElement('div');
        overlay.classList.add('buy-it-now-overlay');
        
        const message = document.createElement('span');
        message.textContent = window.buyItNowStrings?.checking_availability || 'Checking Availability';
        overlay.appendChild(message);
        
        return overlay;
      }

      showPremiumTransition() {
        // Set flag to indicate we're intentionally going to checkout
        sessionStorage.setItem('isGoingToCheckout', 'true');
        
        // Add body class for page zoom effect
        document.body.classList.add('checkout-transitioning');
        
        // Create premium transition overlay
        const transitionOverlay = document.createElement('div');
        transitionOverlay.className = 'premium-checkout-transition';
        
        // Create content container
        const content = document.createElement('div');
        content.className = 'premium-checkout-transition-content';
        
        // Create icon with circle
        const icon = document.createElement('div');
        icon.className = 'premium-checkout-transition-icon';
        
        const circle = document.createElement('div');
        circle.className = 'premium-checkout-transition-circle';
        icon.appendChild(circle);
        
        // Create main text
        const text = document.createElement('div');
        text.className = 'premium-checkout-transition-text';
        text.textContent = window.buyItNowStrings?.taking_to_checkout || 'Taking You to Checkout';
        
        // Create subtext
        const subtext = document.createElement('div');
        subtext.className = 'premium-checkout-transition-subtext';
        subtext.textContent = window.buyItNowStrings?.preparing_experience || 'Preparing your premium experience...';
        
        // Assemble everything
        content.appendChild(icon);
        content.appendChild(text);
        content.appendChild(subtext);
        transitionOverlay.appendChild(content);
        document.body.appendChild(transitionOverlay);
        
        // Activate transition with a slight delay for smooth effect
        setTimeout(() => {
          transitionOverlay.classList.add('active');
        }, 50);
      }
    }
  );
}

// Global cleanup handler for browser back-forward cache (bfcache)
// This is essential for mobile browsers (iOS Safari, Chrome mobile) which restore pages from cache
window.addEventListener('pageshow', function(event) {
  // If the page was restored from bfcache (back/forward button)
  if (event.persisted) {
    // Clean up any leftover transition elements
    const existingTransitions = document.querySelectorAll('.premium-checkout-transition');
    existingTransitions.forEach(el => el.remove());
    document.body.classList.remove('checkout-transitioning');
    
    // Clear the checkout flag
    sessionStorage.removeItem('isGoingToCheckout');
    
    // Also clean up any overlays that might be stuck
    const overlays = document.querySelectorAll('.buy-it-now-overlay');
    overlays.forEach(overlay => {
      overlay.style.display = 'none';
    });
    
    // Reset checkout button state
    const checkoutButtons = document.querySelectorAll('button[name="checkout"]');
    checkoutButtons.forEach(button => {
      button.style.pointerEvents = '';
    });
  }
});

